
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_9timp_94",
  "wizard": "awsui_wizard_1xupv_9timp_105",
  "refresh": "awsui_refresh_1xupv_9timp_105",
  "small-container": "awsui_small-container_1xupv_9timp_112",
  "navigation": "awsui_navigation_1xupv_9timp_120",
  "number": "awsui_number_1xupv_9timp_148",
  "circle": "awsui_circle_1xupv_9timp_164",
  "title": "awsui_title_1xupv_9timp_172",
  "active": "awsui_active_1xupv_9timp_201",
  "disabled": "awsui_disabled_1xupv_9timp_212",
  "enabled": "awsui_enabled_1xupv_9timp_222",
  "form": "awsui_form_1xupv_9timp_261",
  "form-header": "awsui_form-header_1xupv_9timp_267",
  "background": "awsui_background_1xupv_9timp_278",
  "form-header-content": "awsui_form-header-content_1xupv_9timp_288",
  "form-component": "awsui_form-component_1xupv_9timp_292",
  "hidden": "awsui_hidden_1xupv_9timp_306",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_9timp_310",
  "collapsed-steps-extra-padding": "awsui_collapsed-steps-extra-padding_1xupv_9timp_315",
  "collapsed-steps-hidden": "awsui_collapsed-steps-hidden_1xupv_9timp_318",
  "form-header-component-wrapper": "awsui_form-header-component-wrapper_1xupv_9timp_322",
  "form-header-component": "awsui_form-header-component_1xupv_9timp_322",
  "navigation-link": "awsui_navigation-link_1xupv_9timp_335",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_9timp_336",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_9timp_337",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_9timp_341",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_9timp_346",
  "cancel-button": "awsui_cancel-button_1xupv_9timp_350",
  "previous-button": "awsui_previous-button_1xupv_9timp_351",
  "primary-button": "awsui_primary-button_1xupv_9timp_352",
  "skip-to-button": "awsui_skip-to-button_1xupv_9timp_353",
  "action-buttons": "awsui_action-buttons_1xupv_9timp_357"
};
  